<template>
	<Search @onSearch="onSubmit" @onReset="onClear" ref="search" :labelWidth="116">
		<div class="yx-form-wrap">
			<el-form inline :model="form" label-width="116px">
				<el-form-item :label="labelAnchorName">
					<el-input v-model="form.anchorName" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item v-if="$isPlatOr(['Dy', 'Ks', 'Xhs'])" :label="platformId | formatPlatformName('suf')">
					<el-input v-model="form.anchorAccount" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item v-if="$isSp() || $isDy()" :label="labelAnchorUid">
					<el-input v-model="form.anchorUid" clearable placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="拉黑时间">
					<el-date-picker
						v-model="blackTime"
						type="daterange"
						@change="changTime"
						value-format="timestamp"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
					></el-date-picker>
				</el-form-item>
			</el-form>
		</div>
		<template slot="operate" v-if="$slots['operate']">
			<slot name="operate"></slot>
		</template>
	</Search>
</template>
<script>
import { startOfDay, endOfDay } from 'date-fns';

export default {
	props: {
		platformId: {
			type: [Number, String],
			default: dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {
			form: {
				anchorName: '',
				anchorAccount: '',
				anchorUid: '',
				blockTimeStart: '',
				blockTimeEnd: '',
			},
			blackTime: [],
		};
	},
	created() {},
	computed: {
		labelAnchorName() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: '达人昵称',
				[dataMap.PLATFORM_KS.value]: '达人昵称',
				[dataMap.PLATFORM_SP.value]: '视频号名称',
				[dataMap.PLATFORM_XHS.value]: '达人昵称',
			};
			return temPF[this.platformId];
		},
		labelAnchorUid() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: '抖音UID',
				[dataMap.PLATFORM_SP.value]: '视频号ID',
			};
			return temPF[this.platformId];
		},
	},
	methods: {
		onSubmit() {
			this.$emit('onSubmit', this.form);
		},
		onClear() {
			this.form = {
				anchorName: '',
				anchorAccount: '',
				anchorUid: '',
				blockTimeStart: '',
				blockTimeEnd: '',
			};
			this.blackTime = [];
			this.onSubmit();
		},
		changTime(val) {
			let [startTime, endTime] = val || [];
			this.form['blockTimeStart'] = startTime ? Math.trunc(startOfDay(startTime) / 1000) : '';
			this.form['blockTimeEnd'] = endTime ? Math.trunc(endOfDay(endTime) / 1000) : '';
		},
	},
};
</script>

<style lang="less" scoped>
/deep/ .el-input__inner input.el-range-input::placeholder {
	font-size: 14px !important;
}
</style>
